import React from 'react';
import styles from './style.module.scss';
import Image from 'next/image';

import type { ListingAgentInfo } from 'components/dynamic-page/listing-page/listing-agent';

export default function ListingAgentInPvr({ agentInfo }: { agentInfo: ListingAgentInfo }) {
  const agentPic = agentInfo?.photo ? agentInfo?.photo : '/next/assets/images/agent-search/agent-default-profile-pic.png';

  return (agentInfo &&
    <div className={styles.component}>
      <div className={styles['content-container']}>
        <div className={styles['left-agent']}>
          <Image src={agentPic} alt={agentInfo?.firstName} className={styles['avatar-large']} width={60} height={60}/>
          <div className={styles['agent-info']}>
            <p className={styles['agent-grey-title']}>LISTING AGENT</p>
            <p className={styles['agent-name']}>{agentInfo?.firstName} {agentInfo?.lastName}</p>
            <p className={styles['agent-title']}>{agentInfo?.title || 'eXp Realty Agent'}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
